import "./contact.css";

import React from "react";
import { Button, TextField, Select, FormControl, InputLabel, MenuItem, CircularProgress } from "@material-ui/core";
import { Email, Phone, WhatsApp } from "@material-ui/icons";

import { LOADING_STATE, PAGE_ROUTES } from "../../utils/stateTypes";
import SEO_DATA from "../../utils/seoData";
import SeoHead from "../general/SeoHead";

const styles = {
  contactIcon: {
    width: "100%",
    height: "100%",
  },
  inputHalf: {
    width: "calc(50% - 10px)",
    marginBottom: 20,
    marginRight: 20,
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  inputHalf2: {
    width: "calc(50% - 10px)",
    marginBottom: 20,
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  input: {
    marginBottom: 20,
    textAlign: "left",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  },
  submit: {
    padding: "15px",
  },
};

const sendMessage = async (name, email, type, phone, message, setSendState) => {
  setSendState(LOADING_STATE.LOADING);
  const response = await fetch("/api/Contact/SendContactMessage", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      name,
      email,
      phone,
      type,
      message,
    }),
  });
  if (response.ok) {
    setSendState(LOADING_STATE.LOADED);
  }
  else {
    setSendState(LOADING_STATE.ERROR);
  }
};


const Contact = () => {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [type, setType] = React.useState("Ask a question");
  const [phone, setPhone] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [sendState, setSendState] = React.useState(LOADING_STATE.NOT_LOADING);

  let submitLabel = "Send";
  if (sendState === LOADING_STATE.LOADING) {
    submitLabel = <CircularProgress size={25} />;
  }
  else if (sendState === LOADING_STATE.LOADED) {
    submitLabel = "Sent!";
  }
  else if (sendState === LOADING_STATE.ERROR) {
    submitLabel = "Retry";
  }

  return (
    <main>
      <SeoHead
        {...SEO_DATA[PAGE_ROUTES.CONTACT]}
        path={PAGE_ROUTES.CONTACT}
      />

      <header className={"page-header standard-width"}>
        <h1 className={"section-head"}>Contact</h1>
      </header>

      <section className={"contact-section standard-width"}>
        <div className={"contact-blocks"}>
          <div className={"contact-block standard-box"}>
            <div className={"contact-block-icon"}>
              <Email style={styles.contactIcon} />
            </div>
            <p>
              ashthedietitian<span style={{ display: "none" }}>botblocker</span>@gmail.com
            </p>
            <div className={"contact-block-bg"} />
          </div>
          <div className={"contact-block standard-box"}>
            <div className={"contact-block-icon"}>
              <Phone style={styles.contactIcon} />
            </div>
            <p>
              +27 76 271 8052
            </p>
            <div className={"contact-block-bg"} />
          </div>
          <a
            className={"contact-block standard-box"}
            href={"https://wa.me/27762718052"}
            target={"_blank"}
            rel={"noreferrer"}
          >
            <div className={"contact-block-icon"}>
              <WhatsApp style={styles.contactIcon} />
            </div>
            <p>
              Click to message
            </p>
            <div className={"contact-block-bg"} />
          </a>
        </div>
      </section>

      <section className={"map-section standard-width"}>
        <div className={"map-info"}>
          <h2>Johannesburg</h2>
          <p>
            Inbody Weigh-in Facility
            <br />
            4 Ashwold Rd, Johannesburg, 2196
          </p>
        </div>
        <iframe
          src={"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.0820559714093!2d28.03288441258577!3d-26.161456977007504!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e950c63e5fbe02d%3A0x18e484fea4fb3b8f!2s4%20Ashwold%20Rd%2C%20Johannesburg%2C%202196%2C%20South%20Africa!5e0!3m2!1sen!2snl!4v1749021242323!5m2!1sen!2snl"}
          allowFullScreen={true}
          loading={"lazy"}
          referrerPolicy={"no-referrer-when-downgrade"}
          className={"map standard-box"}
          title={"Ash The Dietitian Johannesburg Location"}
        />
      </section>

      <section className={"map-section standard-width"}>
        <div className={"map-info alt show-when-sm"}>
          <h2>Cape Town</h2>
          <p>
            V&A Waterfront, Suite 007 (Ground Floor), Granger Bay Court, Granger Road, Cape Town, 8001
          </p>
        </div>
        <iframe
          src={"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13245.415829445006!2d18.4238673!3d-33.90628864999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1dcc6750cf9544a5%3A0x1dc3860578bb4780!2sV%26A%20Waterfront!5e0!3m2!1sen!2sza!4v1772104876244!5m2!1sen!2sza"}
          allowFullScreen={true}
          loading={"lazy"}
          referrerPolicy={"no-referrer-when-downgrade"}
          className={"map standard-box"}
          title={"Ash The Dietitian Cape Town Location"}
        />
        <div className={"map-info alt hide-when-sm"}>
          <h2>Cape Town</h2>
          <p>
            V&A Waterfront, Suite 007 (Ground Floor), Granger Bay Court, Granger Road, Cape Town, 8001
          </p>
        </div>
      </section>

      <section className={"contact-form-section standard-width"}>
        <h2>Say hello</h2>
        <form
          className={"contact-form standard-box"}
          onSubmit={(e) => {
            e.preventDefault();
            sendMessage(name, email, type, phone, message, setSendState);
          }}
        >
          <TextField
            label={"Name"}
            variant={"filled"}
            color={"secondary"}
            style={styles.inputHalf}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <TextField
            label={"Email"}
            variant={"filled"}
            color={"secondary"}
            style={styles.inputHalf2}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            label={"Phone number"}
            variant={"filled"}
            color={"secondary"}
            style={styles.input}
            fullWidth
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <FormControl
            variant={"filled"}
            color={"secondary"}
            style={styles.input}
            fullWidth
          >
            <InputLabel>I am enquiring to</InputLabel>
            <Select
              value={type}
              onChange={(e) => setType(e.target.value)}
              MenuProps={{
                disableScrollLock: true,
              }}
              color={"secondary"}
            >
              <MenuItem
                value={"Ask a question"}
                style={styles.menuItem}
              >
                Ask a question
              </MenuItem>
              <MenuItem
                value={"Arrange a consultation"}
                style={styles.menuItem}
              >
                Arrange a consultation
              </MenuItem>
            </Select>
          </FormControl>
          <TextField
            label={"Message"}
            variant={"filled"}
            color={"secondary"}
            style={styles.input}
            fullWidth
            multiline
            minRows={4}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
          <Button
            variant={"contained"}
            color={"primary"}
            type={"submit"}
            fullWidth
            style={styles.submit}
            disabled={(sendState === LOADING_STATE.LOADING || sendState === LOADING_STATE.LOADED)}
          >
            {submitLabel}
          </Button>
        </form>
      </section>
    </main>
  );
};

export default Contact;

